module.exports = __webpack_public_path__ + "img/static.170c3eeb.gif";